import { createReducer, on } from '@ngrx/store';
import { FeatureFlagsChangedAction, FeatureFlagsLoadedAction } from './feature-flags.actions';
import { FeatureFlagsState } from './types';

export const initialState: FeatureFlagsState = {
  loaded: false,
  flags: {},
};

export const featureFlagsReducer = createReducer(
  initialState,
  on(FeatureFlagsLoadedAction, (state, action) => ({
    ...state,
    flags: action.flags,
    loaded: true,
  })),
  on(FeatureFlagsChangedAction, (state, { flags }) => ({
    ...state,
    flags: {
      ...state.flags,
      ...flags,
    },
  })),
);
